"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_linkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "10ec4881-6869-44db-9e58-a4775745801a",
    "data-name": "Layer 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 144.2 144"
  }, props), /*#__PURE__*/React.createElement("title", null, "social-linkedin"), /*#__PURE__*/React.createElement("path", {
    d: "M26,72H56v96H26ZM41.2,24A17.35,17.35,0,1,1,23.8,41.4,17.33,17.33,0,0,1,41.2,24h0",
    transform: "translate(-23.8 -24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,72h29V85h.4c4-7.6,13.91-15.5,28.42-15.5,30.53,0,36.18,19.9,36.18,45.8V168H138V121.2c0-11.2-.2-25.5-15.73-25.5-15.83,0-18.27,12.2-18.27,24.7V168H74Z",
    transform: "translate(-23.8 -24)"
  }));
}

var _default = ic_linkedin;
exports.default = _default;